"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithContainer = exports.TOOLTIP_POSITION = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _useToggle3 = _interopRequireDefault(require("react-use/lib/useToggle"));
var _Tooltip = require("b2b-components/core/components/Tooltip/Tooltip");
var _useOutsideMouseEvent = require("b2b-components/hooks/useOutsideMouseEvent");
var _server = require("b2b-components/utils/server");
var _excluded = ["isHoverable", "rootElementId"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var TOOLTIP_POSITION = /*#__PURE__*/function (TOOLTIP_POSITION) {
  TOOLTIP_POSITION["top"] = "Top";
  TOOLTIP_POSITION["right"] = "Right";
  TOOLTIP_POSITION["left"] = "Left";
  TOOLTIP_POSITION["bottom"] = "Bottom";
  return TOOLTIP_POSITION;
}({});
exports.TOOLTIP_POSITION = TOOLTIP_POSITION;
var WithContainer = function WithContainer(props) {
  var _wrapperRef$current, _wrapperRef$current2;
  var _props$isHoverable = props.isHoverable,
    isHoverable = _props$isHoverable === void 0 ? true : _props$isHoverable,
    rootElementId = props.rootElementId,
    originalProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var hasTriggerWidth = originalProps.hasTriggerWidth,
    content = originalProps.content;
  var _useToggle = (0, _useToggle3["default"])(false),
    _useToggle2 = (0, _slicedToArray2["default"])(_useToggle, 2),
    isVisible = _useToggle2[0],
    toggleHandler = _useToggle2[1];
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    hasPositionCalculated = _useState2[0],
    setHasPositionCalculated = _useState2[1];
  var scrollY = !_server.isServer ? window.scrollY : 0;
  var body = !_server.isServer ? document.body : undefined;
  var clientHeight = (body === null || body === void 0 ? void 0 : body.clientHeight) || 0;
  var clientWidth = (body === null || body === void 0 ? void 0 : body.clientWidth) || 0;
  var wrapperRef = (0, _react.useRef)(null);
  var contentRef = (0, _react.useRef)(null);
  var triggerLeft = ((_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.getBoundingClientRect().left) || 0;
  var triggerTop = ((_wrapperRef$current2 = wrapperRef.current) === null || _wrapperRef$current2 === void 0 ? void 0 : _wrapperRef$current2.getBoundingClientRect().top) || 0;
  (0, _useOutsideMouseEvent.useOutsideMouseEvent)('click', [wrapperRef], function () {
    if (isVisible) {
      toggleHandler(false);
      setHasPositionCalculated(false);
    }
  }, {
    rootElementId: rootElementId
  });
  (0, _useOutsideMouseEvent.useOutsideMouseEvent)('mouseover', [contentRef, wrapperRef], function () {
    if (isVisible && isHoverable) {
      toggleHandler(false);
      setHasPositionCalculated(false);
    }
  }, {
    options: {
      capture: true
    }
  });
  var handleMouseEnter = (0, _react.useCallback)(function () {
    if (isHoverable) {
      toggleHandler(true);
    }
  }, [toggleHandler, isHoverable]);
  var handleMouseLeave = (0, _react.useCallback)(function () {
    if (isHoverable) {
      toggleHandler(false);
    }
  }, [toggleHandler, isHoverable]);
  var handleClick = (0, _react.useCallback)(function (e) {
    e.stopPropagation();
    toggleHandler();
  }, [toggleHandler]);
  var _useState3 = (0, _react.useState)({
      left: triggerLeft,
      top: triggerTop,
      orientation: TOOLTIP_POSITION.bottom,
      width: 0
    }),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    positionConfig = _useState4[0],
    setPositionConfig = _useState4[1];
  (0, _react.useEffect)(function () {
    if (isVisible && contentRef.current && wrapperRef.current) {
      var triangleSpacing = 5;
      //measure sizes and distances
      var tooltipHeight = contentRef.current.offsetHeight;
      var tooltipWidth = contentRef.current.offsetWidth;
      var triggerHeight = wrapperRef.current.offsetHeight;
      var triggerWidth = wrapperRef.current.offsetWidth;
      var _triggerLeft = wrapperRef.current.getBoundingClientRect().left || 0;
      var _triggerTop = wrapperRef.current.getBoundingClientRect().top || 0;
      var triggerRight = clientWidth - (_triggerLeft + triggerWidth);
      var triggerBottom = clientHeight - scrollY - (_triggerTop + triggerHeight);
      var left = contentRef.current.getBoundingClientRect().left || 0;
      var top = contentRef.current.getBoundingClientRect().top || 0;
      var orientation = TOOLTIP_POSITION.bottom;
      var width = 0;
      if (hasTriggerWidth) {
        left = _triggerLeft;
        top = _triggerTop + scrollY + triggerHeight + triangleSpacing;
        width = triggerWidth;
      } else if (
      //its okay to stay at the bottom
      _triggerLeft - tooltipWidth / 2 >= 0 && triggerRight - tooltipWidth / 2 >= 0 || triggerWidth >= tooltipWidth) {
        left = _triggerLeft - tooltipWidth / 2 + triggerWidth / 2;
        top = _triggerTop + scrollY + triggerHeight + triangleSpacing;
      } else if (triggerRight - tooltipWidth / 2 < 0) {
        //needs to be moved to the left
        left = _triggerLeft - tooltipWidth - triangleSpacing;
        top = _triggerTop + scrollY + triggerHeight / 2 - tooltipHeight / 2;
        orientation = TOOLTIP_POSITION.left;
      } else if (_triggerLeft - tooltipWidth / 2 < 0) {
        //needs to be moved to the right
        left = _triggerLeft + triggerWidth + triangleSpacing;
        top = _triggerTop + scrollY + triggerHeight / 2 - tooltipHeight / 2;
        orientation = TOOLTIP_POSITION.right;
      }
      if (triggerBottom - tooltipHeight < 0) {
        //needs to be moved to the top
        top = _triggerTop + scrollY - tooltipHeight - triangleSpacing;
        orientation = TOOLTIP_POSITION.top;
      }
      setHasPositionCalculated(true);
      setPositionConfig({
        left: left,
        top: top,
        orientation: orientation,
        width: width
      });
    }
  }, [isVisible, clientHeight, clientWidth, hasTriggerWidth, scrollY, content]);
  var injectedProps = {
    isVisible: isVisible,
    hasPositionCalculated: hasPositionCalculated,
    positionConfig: positionConfig,
    wrapperRef: wrapperRef,
    contentRef: contentRef,
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  };
  return /*#__PURE__*/_react["default"].createElement(_Tooltip.Tooltip, (0, _extends2["default"])({}, originalProps, injectedProps));
};
exports.WithContainer = WithContainer;